import { PageHero } from "@/components/layout/PageHero";
import { faq } from "@/content/legal";
import type { Locale } from "@/i18n/locales";

type FaqViewProps = {
  locale: Locale;
};

export function FaqView({ locale }: FaqViewProps) {
  const copy = faq[locale];

  return (
    <main className="bg-background">
      <PageHero title={copy.title} intro={copy.intro} />
      <div className="mx-auto max-w-4xl px-5 pb-24">
        <div className="space-y-8">
          {copy.groups.map((group) => (
            <section
              key={group.heading}
              className="rounded-2xl border border-border bg-white p-7 shadow-sm"
            >
              <h2 className="font-heading text-2xl font-bold text-[#1a3a5c]">
                {group.heading}
              </h2>
              <div className="mt-6 divide-y divide-border">
                {group.items.map((item) => (
                  <details
                    key={item.q}
                    className="group py-5 first:pt-0 last:pb-0"
                  >
                    <summary className="cursor-pointer list-none font-heading text-lg font-bold text-[#1a3a5c]">
                      {item.q}
                    </summary>
                    <p className="mt-3 leading-7 text-muted-foreground">
                      {item.a}
                    </p>
                  </details>
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
    </main>
  );
}
